import { render, staticRenderFns } from "./SonIslemTarihiAyariList.vue?vue&type=template&id=8ccac4e6&scoped=true"
import script from "./SonIslemTarihiAyariList.vue?vue&type=script&lang=ts"
export * from "./SonIslemTarihiAyariList.vue?vue&type=script&lang=ts"
import style0 from "./SonIslemTarihiAyariList.vue?vue&type=style&index=0&id=8ccac4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccac4e6",
  null
  
)

export default component.exports